import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

import { RouteWithLayout } from './components';
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';

import RequireNotAuth from './components/HOC/RequireNotAuth';
import RequireAuth from './components/HOC/RequireAuth';

import {
  Dashboard as DashboardView,
  Category as CategoryView,
  Player as PlayerView,
  AddressDB as AddressDBView,
//  Position as PositionView,
  Template as TemplateView,
  Campaign as CampaignView,
  Company as CompanyView,
  Device as DeviceView,
  Statistics as StatisticsView,
  Settlement as SettlementView,
  Manage as ManageView,
  SignIn as SignInView,
  NotFound as NotFoundView
} from './views';

const AuthedDashboard = RequireAuth(DashboardView);
const Authed_Category = RequireAuth(CategoryView);
const Authed_Player = RequireAuth(PlayerView);
// const Authed_Position = RequireAuth(PositionView);
// const Authed_Welcome = RequireAuth(PlayerView);
const Authed_AddressDB = RequireAuth(AddressDBView);
const Authed_Template = RequireAuth(TemplateView);
const Authed_Campaign = RequireAuth(CampaignView);
const Authed_Company = RequireAuth(CompanyView);
const Authed_Device = RequireAuth(DeviceView);
const Authed_Statistics = RequireAuth(StatisticsView);
const Authed_Settlement = RequireAuth(SettlementView);
const Authed_Manage = RequireAuth(ManageView);
const NotAuthedSignIn = RequireNotAuth(SignInView);
const NotAuthedNotFound = RequireNotAuth(NotFoundView);

const Routes = () => {
  return (
    <Switch>
      <Redirect
        exact
        from="/"
        to="/main"
      />
      <RouteWithLayout
        component={AuthedDashboard}
        exact
        layout={MainLayout}
        path="/main"
      />
      <RouteWithLayout
        component={Authed_Category}
        exact
        layout={MainLayout}
        path="/category"
      />
      <RouteWithLayout
        component={Authed_Player}
        exact
        layout={MainLayout}
        path="/advertise/player"
      />
      <RouteWithLayout
        component={Authed_AddressDB}
        exact
        layout={MainLayout}
        path="/advertise/addressdb"
      />
      {/* <RouteWithLayout
        component={Authed_Position}
        exact
        layout={MainLayout}
        path="/advertise/position"
      />
      <RouteWithLayout
        component={Authed_Welcome}
        exact
        layout={MainLayout}
        path="/advertise/welcome"
      /> */}
      <RouteWithLayout
        component={Authed_Template}
        exact
        layout={MainLayout}
        path="/advertise/:template/:category"
      />
      <RouteWithLayout
        component={Authed_Campaign}
        exact
        layout={MainLayout}
        path="/campaign"
      />
      <RouteWithLayout
        component={Authed_Company}
        exact
        layout={MainLayout}
        path="/company/:type"
      />
      <RouteWithLayout
        component={Authed_Device}
        exact
        layout={MainLayout}
        path="/device/:type"
      />
      <RouteWithLayout
        component={Authed_Statistics}
        exact
        layout={MainLayout}
        path="/statistics/:type"
      />
      <RouteWithLayout
        component={Authed_Settlement}
        exact
        layout={MainLayout}
        path="/settlement/:type"
      />
      <RouteWithLayout
        component={Authed_Manage}
        exact
        layout={MainLayout}
        path="/manage/:type"
      />
      <RouteWithLayout
        component={NotAuthedSignIn}
        exact
        layout={MinimalLayout}
        path="/sign-in"
      />
      <RouteWithLayout
        component={NotAuthedNotFound}
        exact
        layout={MinimalLayout}
        path="/not-found"
      />
      <Redirect to="/not-found" />
    </Switch>
  );
};

export default Routes;
